import { genericPost } from "./apiService";
import { API_URL } from "../config/env";

export const ComplaintRequest = async (request) => {
  try {
    const response = await genericPost(`${API_URL}Complaint/Add`, {
      PID: request.pid,
      Note: request.description,
      Type: request.type
    });
    return response;
  } catch (error) {
    console.error('Error in ComplaintRequest:', error);
    throw error;
  }
}; 